











import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LadingForm from "@/modules/ladings/Form/index.vue";
import LadingTable from "@/modules/ladings/List/components/Table.vue";
import {LadingStore} from "@/modules/ladings/store";
import {LadingParams} from "@/modules/ladings/params";
import {LadingStatus} from "@/enums/status";
import LadingSearchForUpdate from "@/modules/ladings/List/components/SearchForUpdate.vue";
import {isFF} from "ant-design-vue/es/_util/env";
import LadingUpdate from "@/modules/ladings/Form/Update.vue";
Component.registerHooks([
    'beforeRouteLeave'
])

@Component({
    name: "LadingFormUpdate",
    components: {LadingUpdate, LadingSearchForUpdate, LadingTable, LadingForm},
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly id!: string;

    ladingId = null;

    beforeRouteLeave(to, from, next) {
        if (LadingStore.isDirtyForm) {
            const answer = window.confirm("Dữ liệu thay đổi chưa được lưu, bạn muốn chuyển trang ?");
            if (answer) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    }

    created() {
        if (!this.id) {
            const params = {...new LadingParams()};
            LadingStore.updateLadingParams(params);
            LadingStore.listLadingNeedUpdate({...LadingStore.params});
        }
    }

    mounted() {
        this.ladingId = this.id as any;
    }

    get showDetailLading() {
        return !!this.id;
    }

    handleUpdateLading(val: any) {
        LadingStore.setIsNextUpdateLading(true);
        this.ladingId = val;
    }
}
